'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'spinner-third';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f3f4';
var svgPathData = ['M0 256c0 141.4 114.6 256 256 256 107.8 0 200-66.6 237.8-160.9-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.2-17.8-41.7C406.1 398 336.9 448 256 448 150 448 64 362 64 256S150 64 256 64c9.3 0 18.5 .7 27.5 1.9-17.5-2.5-29.6-18.7-27.1-36.2 2.5-17.2 18.2-29.3 35.4-27.3-11.7-1.6-23.6-2.5-35.8-2.5-141.4 0-256 114.6-256 256z', 'M256.3 29.7c2.5-17.5 18.7-29.6 36.2-27.1 124.1 17.8 219.5 124.4 219.5 253.4 0 33.5-6.5 65.6-18.2 95.1-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.2-17.8-41.6c8.8-22 13.7-46 13.7-71.3 0-96.7-71.5-176.7-164.5-190.1-17.5-2.5-29.6-18.7-27.1-36.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpinnerThird = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;